import {Button, Popover} from 'antd';

import {Text} from '../../../../../../../component/text/text';
import {Locale} from '../../../../../../../provider/locale/localization';
import {GoodPlaceYearEnum} from '../../../../../../../service/reivew-analysis/rating-dynamics/reviews-analytics-ratings-dynamic-type';

import WgisGoodPlaceYearNominee from './images/wgis-good-place-year-nominee.svg';
import {getAwards2GisLink} from './wgis-good-place-year-mark-helper';
import * as styles from './wgis-good-place-year-mark.scss';

type PropsType = {
    goodPlaceYear?: GoodPlaceYearEnum | null;
};

export function WgisGoodPlaceYearMark(props: PropsType): JSX.Element | null {
    const {goodPlaceYear} = props;

    // eslint-disable-next-line no-undefined
    if (goodPlaceYear === null || goodPlaceYear === undefined) {
        return null;
    }

    return (
        <Popover
            className={styles.WgisGoodPlaceYearMark_popoverContent}
            content={
                <div className={styles.WgisGoodPlaceYearMark_popoverContent}>
                    <Text block stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__WGIS_GOOD_PLACE_YEAR_CONTENT" />
                    <Button
                        className={styles.WgisGoodPlaceYearMark_popoverLink}
                        href={getAwards2GisLink()}
                        target="_blank"
                        type="link"
                    >
                        <Locale stringKey="TEXT__MORE_DETAILS" />
                    </Button>
                </div>
            }
            title={
                <Text
                    block
                    bolder
                    className={styles.WgisGoodPlaceYearMark_popoverTitle}
                    stringKey="REVIEWS_ANALYSIS__RATINGS_DYNAMIC_TABLE__WGIS_GOOD_PLACE_YEAR_TITLE"
                />
            }
        >
            <div className={styles.WgisGoodPlaceYearMark}>
                <img alt="" role="presentation" src={WgisGoodPlaceYearNominee} />
            </div>
        </Popover>
    );
}
